namespace Matrix.Indexation {
    export interface IndexConstituentRorRow {
        IndexationProfileCode?: string;
        CompositeCode?: string;
        IndexCode?: string;
        BaseDate?: string;
        EffectiveDate?: string;
        SourceCode?: string;
        LocalReturn?: number;
        CurrencyReturn?: number;
        HedgedReturn?: number;
        UnhedgedReturn?: number;
        TotalReturn?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        IndexationProfileName?: string;
        IndexationProfileIndexationInstanceId?: string;
        IndexationProfileEffectiveDate?: string;
        IndexationProfileValidFrom?: string;
        IndexationProfileValidTo?: string;
        IndexationProfileShortName?: string;
        IndexationProfileRowId?: number;
        IndexationProfileDefaultSortOrder?: number;
        CompositeName?: string;
        CompositeLocalCurrencyCode?: string;
        CompositeIndexTypeCode?: string;
        CompositePriceSource1?: string;
        CompositePriceSource1Id?: string;
        CompositePriceSource2?: string;
        CompositePriceSource2Id?: string;
        CompositeFxOtherCurrency?: string;
        CompositeRowId?: number;
        CompositeDefaultSortOrder?: number;
        IndexName?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        SourceName?: string;
        SourceGroup?: string;
        SourceCategory?: string;
        SourceId?: number;
        SourceRowId?: number;
    }

    export namespace IndexConstituentRorRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.IndexConstituentRor';
        export const deletePermission = 'DataAdmin:IndexConstituentRor';
        export const insertPermission = 'DataAdmin:IndexConstituentRor';
        export const readPermission = 'Read:IndexConstituentRor';
        export const updatePermission = 'DataAdmin:IndexConstituentRor';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            CompositeCode = "CompositeCode",
            IndexCode = "IndexCode",
            BaseDate = "BaseDate",
            EffectiveDate = "EffectiveDate",
            SourceCode = "SourceCode",
            LocalReturn = "LocalReturn",
            CurrencyReturn = "CurrencyReturn",
            HedgedReturn = "HedgedReturn",
            UnhedgedReturn = "UnhedgedReturn",
            TotalReturn = "TotalReturn",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            IndexationProfileName = "IndexationProfileName",
            IndexationProfileIndexationInstanceId = "IndexationProfileIndexationInstanceId",
            IndexationProfileEffectiveDate = "IndexationProfileEffectiveDate",
            IndexationProfileValidFrom = "IndexationProfileValidFrom",
            IndexationProfileValidTo = "IndexationProfileValidTo",
            IndexationProfileShortName = "IndexationProfileShortName",
            IndexationProfileRowId = "IndexationProfileRowId",
            IndexationProfileDefaultSortOrder = "IndexationProfileDefaultSortOrder",
            CompositeName = "CompositeName",
            CompositeLocalCurrencyCode = "CompositeLocalCurrencyCode",
            CompositeIndexTypeCode = "CompositeIndexTypeCode",
            CompositePriceSource1 = "CompositePriceSource1",
            CompositePriceSource1Id = "CompositePriceSource1Id",
            CompositePriceSource2 = "CompositePriceSource2",
            CompositePriceSource2Id = "CompositePriceSource2Id",
            CompositeFxOtherCurrency = "CompositeFxOtherCurrency",
            CompositeRowId = "CompositeRowId",
            CompositeDefaultSortOrder = "CompositeDefaultSortOrder",
            IndexName = "IndexName",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            SourceName = "SourceName",
            SourceGroup = "SourceGroup",
            SourceCategory = "SourceCategory",
            SourceId = "SourceId",
            SourceRowId = "SourceRowId"
        }
    }
}
